import { createShader, colorUniform } from "./ShaderBase.js";

export const fireShader = createShader({
  customizable: [
    { uniform: "uColorCore", label: "Core", default: "#ffcc00" },
    { uniform: "uColorFlame", label: "Flame", default: "#ff4400" },
  ],

  uniforms: {
    uPixelSize: { value: 10.0 },
    uScale: { value: 1.0 },
    uSpeed: { value: 0.3 },
    uColorCore: colorUniform("#ffcc00"),
    uColorFlame: colorUniform("#ff4400"),
    uColorSmoke: colorUniform("#1a0a00"),
    uGradientHeight: { value: 8.0 },
  },

  fragmentUniforms: `
    uniform vec3 uColorCore;
    uniform vec3 uColorFlame;
    uniform vec3 uColorSmoke;
    uniform float uGradientHeight;
  `,

  fragmentBody: `
    // World-space gradient (hotter at bottom, cooler at top)
    float normalizedY = (pixelatedPos.y + uGradientHeight * 0.5) / uGradientHeight;
    normalizedY = clamp(normalizedY, 0.0, 1.0);
    float heightFactor = 1.0 - normalizedY;

    // Turbulent fire noise in 3D space (slow upward drift)
    vec3 firePos = pixelatedPos * 1.5 + vec3(0.0, -uTime * uSpeed, 0.0);
    float fire1 = snoise(firePos);
    float fire2 = snoise(firePos * 2.0 + vec3(100.0)) * 0.5;
    float fire = (fire1 + fire2) / 1.5;

    // Fire intensity combines noise and height
    float intensity = (fire + 1.0) * 0.5;
    intensity = intensity * (0.4 + heightFactor * 0.6);
    intensity = pow(intensity, 0.8);

    // Color gradient from smoke (dark) to flame (orange) to core (bright)
    vec3 color = uColorSmoke;
    color = mix(color, uColorFlame, smoothstep(0.15, 0.45, intensity));
    color = mix(color, uColorCore, smoothstep(0.5, 0.85, intensity));

    // Flickering embers throughout
    float emberTime = floor(uTime * uSpeed * 8.0);
    float ember = snoise(pixelatedPos * 25.0 + vec3(emberTime * 0.5));
    float emberShow = step(0.90, (ember + 1.0) * 0.5);
    color = mix(color, uColorCore * 1.3, emberShow * 0.7);

    gl_FragColor = vec4(color, 1.0);
  `,
});
